<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="/" class="footer-link">gbwtsapp.com</a> This site only shares guides and information about GB WhatsApp. We are not the developer.</p>
    </div>
    <div class="footer-links">
      <a href="/contact-us/" class="footer-link">Contact Us</a>
      |
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
      |
      <a href="/privacy-policy/" class="footer-link">Privacy Policy</a>
      |
      <a href="/terms-of-use/" class="footer-link">Terms of Use</a>
    </div>

  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
  text-align: center;
}
@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

.footer-container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px 12px;
  width: 100%;
  color: #1b3d76;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-links .footer-link {
  font-size: 14px;
}

.footer-note {
  font-size: 15px;
  width: 100%;
  text-align: center;

  p {
    margin: 0;
    text-align: center;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    padding: 0 20px;
  }

  .footer-links {
    margin-bottom: 0;
    gap: 6px 10px;
    font-size: 12px;
  }

  .footer-links .footer-link {
    font-size: 12px;
  }

  .footer-note {
    font-size: 12px;
  }
}
</style>
